import {loadStripe} from '@stripe/stripe-js';


export const stripePromise = loadStripe("pk_test_51LukMvIbFHa7bfcX82m1k4W5W6JUmNel0vLcKfXRdJ8ql8E6rGjLKxA6lDZGRNQzYaWBG12i8S4CMCk0rhzQ1E6H00HuSXhPc0");